import React from 'react';
import PropTypes from 'prop-types';

import ProcessHelpModal from "./process_help_modal.jsx";
import ActivityDetails from "./activity_details.jsx";
import ActivityToolbox from "./activity_toolbox.jsx";
import AssignActivityToUserModal from "./assign_activity_to_user_modal.jsx";
import FlashMessages from "../../flash_message/components/flash_messages.jsx";
import Form from "../../form/components/form/form.jsx";
import FinalActivityMessage from "./final_activity_message.jsx";
import ProcessActionRoutes from "../constants/process_action_routes";
import { FormEventHandler, FormEvents } from "../../form/events/form_event_handler";
import { ActivityFormEventHandler, ActivityFormEvents } from "../events/activity_form_event_handler";
import ActivityTypes from "../constants/activity_types";
import ActivityStatuses from "../constants/activity_statuses";
import LabelHelpTextModal from '../../form/components/label/help_text_modal.jsx';
import CustomModalApi from '../../process/components/custom_modal_api.jsx';

import { FlashMessageAPI } from 'lecom-api';

import { ProcessAPI } from 'lecom-api';
import { ProcessActions } from '../reflux/process_store';

import { getParamUrl } from '../../utils/query_string_parser';
const newWS = getParamUrl("newWS") === "true";

export default class ActivityForm extends React.Component {
	static propTypes = {
		processIds: PropTypes.object,
		processInstanceData: PropTypes.object,
		displayFormHeader: PropTypes.bool,
		waitingForAction: PropTypes.bool,
		formStoreId: PropTypes.string,
		isMobile: PropTypes.bool,
		dataPrintEnabled: PropTypes.bool,
		isECMLicenseFull: PropTypes.bool,
		highContrast: PropTypes.bool
	};

	static defaultProps = {
		processIds: {},
		processInstanceData: {},
		displayFormHeader: true,
		waitingForAction: false,
		isMobile: false,
		dataPrintEnabled: false,
		highContrast: false
	};

	componentDidMount() {
		FormEventHandler.subscribe(FormEvents.DEFINITION_LOAD_SUCCESS, this.markActivityAsRead.bind(this));
		FlashMessageAPI.setDefault("flash-form");
	}

	markActivityAsRead(eventName, formStoreId, formDefinition, response) {
		//TODO: Usar a ProcessAPI
		if(this.props.formStoreId === formStoreId) {
			ProcessActions.markActivityAsRead(this.props.uniqueStoreItemId);
		}
	}

	getStatus() {
		return this.props.processInstanceData.status;
	}

	isActivityInProgress() {
		return this.getStatus() == ActivityStatuses.IN_PROGRESS;
	}

	renderActivityDetails() {

		return <ActivityDetails {...this.props.processInstanceData} />;
	}

	renderActivityToolbox() {

		return (
			<ActivityToolbox
				{...this.props.processInstanceData}
				processIds={this.props.processIds}
				isMobile={this.props.isMobile}
				waitingForAction={this.props.waitingForAction}
				readOnly={this.props.readOnly}
				newWS={newWS}
				/>
		);
	}

	renderActivityMessageByType() {
		const { activityType } = this.props.processInstanceData;

		switch(activityType) {
			case ActivityTypes.FINAL:
				return <FinalActivityMessage {...this.props.processInstanceData} />;
			default:
				return <span />;
		}
	}

	renderForm() {
		return (
			<Form
				id={this.props.formStoreId}
				definitionURL={ProcessActionRoutes.SHOW_ACTIVITY_FORM}
				definitionParams={{
					processInstanceId: this.props.processIds.processInstanceId,
					activityInstanceId: this.props.processIds.activityInstanceId,
					cycle: this.props.processIds.cycle,
					isMobile: this.props.isMobile
				}}
				formLoaded={false}
				loadOnInit={false}
				waitingForAction={this.props.waitingForAction}
				uniqueStoreItemId={this.props.formStoreId}
				readOnly={this.props.readOnly}
				isMobile={this.props.isMobile}
				dataPrintEnabled={this.props.dataPrintEnabled}
				isECMLicenseFull={this.props.isECMLicenseFull}
				highContrast={this.props.highContrast}/>
		);
	}

		renderActivityToolboxModals() {

			return [
				<ProcessHelpModal {...this.props.processInstanceData} isMobile={this.props.isMobile} />,
				<AssignActivityToUserModal processIds={this.props.processIds} isMobile={this.props.isMobile} />,
				<CustomModalApi modalId="custom-modal-api" isMobile={this.props.isMobile} />
			];
		}

		render() {
			return (
				<div data-testid="activity-form">
					<div className={'card'}>
						{(this.props.displayFormHeader && newWS !== true) && this.renderActivityDetails()} 
						{this.props.displayFormHeader && this.renderActivityToolbox()}

						<div className={'card-content'}>
							<FlashMessages id="flash-form" />
							{this.renderActivityMessageByType()}
							{this.renderForm()}
						</div>
					</div>

					<div id="activity-modal-container">
						{this.renderActivityToolboxModals()}
						<LabelHelpTextModal modalId="help-text-modal" isMobile={this.props.isMobile} />
					</div>
				</div>
			);
		}
	}
